import React, { useEffect, useState, useRef, createElement } from 'react';
import { CheckIcon, ChevronRightIcon, ShieldCheckIcon, ClockIcon, ArrowDownIcon } from 'lucide-react';
import { LegalModal } from './LegalModal';
export function DeBloatLanding() {
  const checkoutRef = useRef<HTMLDivElement>(null);
  // Meta Pixel
  useEffect(() => {
    if ((window as any).fbq) return;
    const f = window as any;
    const n = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [] as any[];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    (window as any).fbq('init', '983975038135863');
    (window as any).fbq('track', 'PageView');
    // noscript fallback
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=983975038135863&ev=PageView&noscript=1';
    document.body.appendChild(img);
    return () => {
      script.remove();
      img.remove();
    };
  }, []);
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const scrollToCheckout = () => {
    checkoutRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  const privacyContent = <div className="space-y-3" data-id="element-1">
      <p data-id="element-2">
        <strong data-id="element-3">Privacy Policy</strong>
      </p>
      <p data-id="element-4">Last updated: {new Date().toLocaleDateString()}</p>
      <p data-id="element-5">
        Plenava ("we", "our", or "us") respects your privacy. This Privacy
        Policy explains how we collect, use, and safeguard your information when
        you purchase our digital products.
      </p>
      <p data-id="element-6">
        <strong data-id="element-7">Information Collection:</strong> We collect information you
        provide directly to us when making a purchase, such as your name and
        email address.
      </p>
      <p data-id="element-8">
        <strong data-id="element-9">Use of Information:</strong> We use the information to process
        your transactions, deliver the digital products, and send related
        communications.
      </p>
      <p data-id="element-10">
        <strong data-id="element-11">Contact Us:</strong> If you have questions about this Privacy
        Policy, please contact us at: plenavaweb@gmail.com
      </p>
    </div>;
  const termsContent = <div className="space-y-3" data-id="element-12">
      <p data-id="element-13">
        <strong data-id="element-14">Terms and Conditions</strong>
      </p>
      <p data-id="element-15">Last updated: {new Date().toLocaleDateString()}</p>
      <p data-id="element-16">
        By purchasing "The 48-Hour De-Bloat Protocol" from Plenava, you agree to
        these terms.
      </p>
      <p data-id="element-17">
        <strong data-id="element-18">Digital Product:</strong> This is a digital eBook. Due to the
        nature of digital products, all sales are final once the download link
        has been provided.
      </p>
      <p data-id="element-19">
        <strong data-id="element-20">Medical Disclaimer:</strong> The information provided in this
        eBook is for educational purposes only and is not intended as medical
        advice. Consult with a healthcare professional before starting any new
        diet or protocol.
      </p>
      <p data-id="element-21">
        <strong data-id="element-22">Copyright:</strong> All content is the property of Plenava. You
        may not reproduce, distribute, or transmit any part of this publication
        without prior written permission.
      </p>
      <p data-id="element-23">
        <strong data-id="element-24">Contact:</strong> plenavaweb@gmail.com
      </p>
    </div>;
  return <div className="min-h-screen bg-brand-bg text-brand-text font-sans selection:bg-brand-cta selection:text-white pb-12" data-id="element-25">
      <main className="max-w-2xl mx-auto px-5 pt-10 pb-16 flex flex-col gap-8 md:gap-10" data-id="element-26">
        {/* HERO SECTION */}
        <header className="text-center space-y-4" data-id="element-27">
          <div className="inline-flex items-center justify-center space-x-1 bg-brand-accent/10 text-brand-accent px-3 py-1 rounded-full text-xs font-semibold tracking-wide uppercase mb-2" data-id="element-28">
            <ClockIcon className="w-3.5 h-3.5" data-id="element-29" />
            <span data-id="element-30">Emergency Reset</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-serif font-bold leading-tight tracking-tight text-brand-text" data-id="element-31">
            The 48-Hour De-Bloat Protocol
          </h1>
          <h2 className="text-lg md:text-xl font-serif italic text-brand-text/80 leading-snug max-w-xl mx-auto" data-id="element-32">
            The emergency "mineral flush" to shed 3–7 lbs of puffiness and fit
            into your clothes by Saturday night.
          </h2>

          {/* HERO MOCKUP */}
          <div className="py-4" data-id="element-33">
            <img src="https://cdn.magicpatterns.com/uploads/ktqM894EbhGx3KtoppW2QX/MOCKUP_1-1.png" alt="The 48-Hour De-Bloat Protocol displayed on a tablet" className="w-full max-w-sm mx-auto rounded-sm" data-id="element-34" />
          </div>

          <div className="pt-4" data-id="element-35">
            <button onClick={scrollToCheckout} className="w-full md:w-auto bg-brand-cta hover:bg-brand-cta-hover text-white font-medium py-3.5 px-8 rounded-sm transition-all duration-200 flex items-center justify-center space-x-2 shadow-lg shadow-brand-cta/20 mx-auto" data-id="element-36">
              <span data-id="element-37">Get The Protocol Now</span>
              <ChevronRightIcon className="w-4 h-4" data-id="element-38" />
            </button>
          </div>
        </header>

        <hr className="border-brand-text/10" data-id="element-39" />

        {/* OPENING HOOK */}
        <section className="space-y-3 text-base leading-snug" data-id="element-40">
          <p className="font-medium text-lg" data-id="element-41">
            You're standing in front of the mirror, and the air leaves the room.
          </p>
          <p data-id="element-42">
            The event is in 48 hours. You've been picturing this outfit for
            weeks, but as you pull the zipper, it's tight. Your rings won't
            slide off. Your face looks "fleshy" and tired in a way that sleep
            won't fix.
          </p>
          <p data-id="element-43">
            Your first instinct is to stop eating or go for a brutal 5-mile run.{' '}
            <strong data-id="element-44">Don't.</strong> Most of what you see isn't fat gained
            overnight—it's systemic inflammation and "false weight" held hostage
            by your cells.
          </p>
        </section>

        {/* THE PROBLEM */}
        <section className="bg-white/50 p-6 rounded-sm border border-brand-text/5 space-y-3 text-base leading-snug" data-id="element-45">
          <h3 className="font-serif text-xl font-semibold mb-2" data-id="element-46">
            The Biological Reality
          </h3>
          <p data-id="element-47">
            By age 30, your body's ability to "bounce back" from a salty meal, a
            glass of wine, or a stressful week changes. Stress triggers
            cortisol, and cortisol tells your kidneys to hoard every drop of
            water it can find.
          </p>
          <p data-id="element-48">
            You feel heavy, your midsection is distended, and you're panicking
            because you need to look your best in less than two days. You don't
            have months for a lifestyle overhaul. You have 48 hours to fix a
            biological chemistry problem.
          </p>
        </section>

        {/* WHY WHAT YOU TRIED DIDN'T WORK */}
        <section className="space-y-4" data-id="element-49">
          <h3 className="font-serif text-2xl font-bold text-center" data-id="element-50">
            Why The "Quick Fixes" Failed You
          </h3>
          <ul className="space-y-3 text-sm md:text-base leading-snug" data-id="element-51">
            <li className="flex items-start" data-id="element-52">
              <span className="text-brand-accent mr-2 mt-0.5 font-bold" data-id="element-53">✕</span>
              <p data-id="element-54">
                <strong data-id="element-55">Juice Cleanses</strong> are sugar bombs that spike
                insulin, which actually forces your kidneys to hold onto even
                more salt and water.
              </p>
            </li>
            <li className="flex items-start" data-id="element-56">
              <span className="text-brand-accent mr-2 mt-0.5 font-bold" data-id="element-57">✕</span>
              <p data-id="element-58">
                <strong data-id="element-59">Standard Diuretics</strong> flush water
                indiscriminately, leaving your muscles looking flat and your
                skin looking "grey" and dehydrated.
              </p>
            </li>
            <li className="flex items-start" data-id="element-60">
              <span className="text-brand-accent mr-2 mt-0.5 font-bold" data-id="element-61">✕</span>
              <p data-id="element-62">
                <strong data-id="element-63">Raw "Superfood" Salads</strong> are gas-factories that
                cause massive intestinal expansion right when you need a flat
                stomach.
              </p>
            </li>
            <li className="flex items-start" data-id="element-64">
              <span className="text-brand-accent mr-2 mt-0.5 font-bold" data-id="element-65">✕</span>
              <p data-id="element-66">
                <strong data-id="element-67">"Sweating it out"</strong> causes systemic stress, which
                triggers more cortisol and more water retention.
              </p>
            </li>
          </ul>
        </section>

        <div className="flex justify-center" data-id="element-68">
          <ArrowDownIcon className="w-6 h-6 text-brand-text/20" data-id="element-69" />
        </div>

        {/* THE UNIQUE MECHANISM */}
        <section className="space-y-3 text-base leading-snug" data-id="element-70">
          <h3 className="font-serif text-2xl font-bold" data-id="element-71">
            The Secret: Mineral Sequencing
          </h3>
          <p data-id="element-72">
            The secret isn't "eating less"—it is{' '}
            <strong data-id="element-73">Mineral Sequencing</strong>. By flooding your system with
            specific ratios of Potassium and Magnesium while eliminating "Hidden
            Swellers," you trigger a biological release valve.
          </p>
          <p data-id="element-74">
            This protocol uses the <em data-id="element-75">"Alchemy Flush"</em> to shift water from
            under your skin back into your cells and out through your kidneys.
            It's not a diet; it's a physiological reset that works in hours, not
            weeks.
          </p>
        </section>

        {/* WHAT YOU GET */}
        <section className="bg-brand-cta/5 p-6 md:p-8 rounded-sm border border-brand-cta/20" data-id="element-76">
          <h3 className="font-serif text-2xl font-bold mb-4 text-center" data-id="element-77">
            Inside The Protocol
          </h3>
          <ul className="space-y-3 text-sm md:text-base leading-snug" data-id="element-78">
            {['The 48-Hour Countdown Calendar (an hour-by-hour roadmap)', 'The "Alchemy Flush" Drink Recipe (the specific mineral ratios for rapid water release)', 'The Forbidden Seven List (the "silent swellers" you must cut immediately)', 'The Low-Residue Meal Plan (foods that absorb fully with zero gas or bloating)', 'The 3-Minute Facial Sculpt (manual lymphatic drainage to reveal your jawline)', 'The 48-Hour Master Checklist & Grocery Rescue List'].map((item, i) => <li key={i} className="flex items-start" data-id="element-79">
                <CheckIcon className="w-5 h-5 text-brand-cta mr-2 shrink-0 mt-0.5" data-id="element-80" />
                <span data-id="element-81">{item}</span>
              </li>)}
          </ul>
        </section>

        {/* WHO IT IS FOR / NOT FOR */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm leading-snug" data-id="element-82">
          <section className="space-y-3" data-id="element-83">
            <h4 className="font-serif font-bold text-lg border-b border-brand-text/10 pb-2" data-id="element-84">
              Who This Is For
            </h4>
            <ul className="space-y-2" data-id="element-85">
              <li className="flex items-start" data-id="element-86">
                <span className="text-brand-cta mr-2" data-id="element-87">•</span>Women 30–60 with a
                wedding, reunion, or photo shoot in 2 days.
              </li>
              <li className="flex items-start" data-id="element-88">
                <span className="text-brand-cta mr-2" data-id="element-89">•</span>Anyone who feels
                "puffy," heavy, or inflamed after a high-sodium weekend.
              </li>
              <li className="flex items-start" data-id="element-90">
                <span className="text-brand-cta mr-2" data-id="element-91">•</span>People who need an
                emergency "reset" button that actually works.
              </li>
            </ul>
          </section>
          <section className="space-y-3" data-id="element-92">
            <h4 className="font-serif font-bold text-lg border-b border-brand-text/10 pb-2" data-id="element-93">
              Who This Is NOT For
            </h4>
            <ul className="space-y-2 text-brand-text/70" data-id="element-94">
              <li className="flex items-start" data-id="element-95">
                <span className="mr-2" data-id="element-96">•</span>People looking for a long-term
                weight loss solution.
              </li>
              <li className="flex items-start" data-id="element-97">
                <span className="mr-2" data-id="element-98">•</span>Anyone with chronic kidney
                disease or severe electrolyte sensitivities.
              </li>
              <li className="flex items-start" data-id="element-99">
                <span className="mr-2" data-id="element-100">•</span>People who want a "magic pill"
                without following a specific 48-hour menu.
              </li>
            </ul>
          </section>
        </div>

        <hr className="border-brand-text/10" data-id="element-101" />

        {/* HOW IT WORKS */}
        <section className="space-y-4" data-id="element-102">
          <h3 className="font-serif text-2xl font-bold text-center" data-id="element-103">
            How It Works
          </h3>
          <div className="space-y-4" data-id="element-104">
            <div className="flex gap-4 items-start" data-id="element-105">
              <div className="w-8 h-8 rounded-full bg-brand-text text-brand-bg flex items-center justify-center font-serif font-bold shrink-0" data-id="element-106">
                1
              </div>
              <p className="text-base leading-snug pt-1" data-id="element-107">
                <strong data-id="element-108">Open the Protocol:</strong> Immediately perform the
                "Alchemy Flush" to signal your kidneys to begin the release.
              </p>
            </div>
            <div className="flex gap-4 items-start" data-id="element-109">
              <div className="w-8 h-8 rounded-full bg-brand-text text-brand-bg flex items-center justify-center font-serif font-bold shrink-0" data-id="element-110">
                2
              </div>
              <p className="text-base leading-snug pt-1" data-id="element-111">
                <strong data-id="element-112">Follow the Mirror Map:</strong> Use the Low-Residue meal
                plan to keep your digestive tract quiet and flat.
              </p>
            </div>
            <div className="flex gap-4 items-start" data-id="element-113">
              <div className="w-8 h-8 rounded-full bg-brand-text text-brand-bg flex items-center justify-center font-serif font-bold shrink-0" data-id="element-114">
                3
              </div>
              <p className="text-base leading-snug pt-1" data-id="element-115">
                <strong data-id="element-116">The Saturday Morning Sculpt:</strong> Perform the
                3-minute lymphatic drainage to remove puffiness from your face
                and ankles.
              </p>
            </div>
          </div>
        </section>

        {/* PROOF */}
        <section className="bg-brand-text text-brand-bg p-6 md:p-8 rounded-sm text-center space-y-3" data-id="element-117">
          <h3 className="font-serif text-xl font-bold text-brand-accent" data-id="element-118">
            What changes in 48 hours:
          </h3>
          <p className="text-base leading-snug text-brand-bg/90" data-id="element-119">
            Most users report a visible shift in jawline definition and a 2–4
            inch reduction in waist bloating. This isn't about losing fat; it's
            about removing the "envelope" of water that hides your actual shape.
          </p>
        </section>

        {/* FAQ */}
        <section className="space-y-4" data-id="element-120">
          <h3 className="font-serif text-2xl font-bold text-center mb-6" data-id="element-121">
            Frequently Asked Questions
          </h3>
          <div className="space-y-4 text-sm md:text-base leading-snug" data-id="element-122">
            <div data-id="element-123">
              <p className="font-bold font-serif text-lg" data-id="element-124">
                "Will I be running to the bathroom all day?"
              </p>
              <p className="text-brand-text/80" data-id="element-125">
                You will experience increased urination as the mineral flush
                works, but it is controlled and manageable.
              </p>
            </div>
            <div data-id="element-126">
              <p className="font-bold font-serif text-lg" data-id="element-127">
                "Can I still drink coffee?"
              </p>
              <p className="text-brand-text/80" data-id="element-128">
                Yes, the protocol includes a specific way to use caffeine as a
                tool, not a hindrance.
              </p>
            </div>
            <div data-id="element-129">
              <p className="font-bold font-serif text-lg" data-id="element-130">"Is this safe?"</p>
              <p className="text-brand-text/80" data-id="element-131">
                This is based on whole-food minerals and hydration. It is
                significantly safer than "diet pills" or extreme fasting.
              </p>
            </div>
            <div data-id="element-132">
              <p className="font-bold font-serif text-lg" data-id="element-133">
                "What if I have to eat out?"
              </p>
              <p className="text-brand-text/80" data-id="element-134">
                We've included a "Safe-Ordering" guide so you can stay on track
                even at a restaurant.
              </p>
            </div>
          </div>
        </section>

        {/* OFFER + PRICE BLOCK (CHECKOUT REF) */}
        <section ref={checkoutRef} className="mt-8 border-2 border-brand-cta p-6 md:p-10 rounded-sm bg-white text-center space-y-6 shadow-xl scroll-mt-6" data-id="element-135">
          <div className="space-y-2" data-id="element-136">
            <h3 className="font-serif text-3xl font-bold" data-id="element-137">
              Start Your First Flush
            </h3>
            <p className="text-base leading-snug text-brand-text/80" data-id="element-138">
              Get the full 48-Hour De-Bloat Protocol today and start within the
              next 30 minutes.
            </p>
          </div>

          {/* CHECKOUT MOCKUP */}
          <div className="py-2" data-id="element-139">
            <img src="https://cdn.magicpatterns.com/uploads/dFGC7r191dmHAZWE3NCgVV/MOCKUP_AUTO.png" alt="The 48-Hour De-Bloat Protocol ebook preview" className="w-full max-w-md mx-auto rounded-sm" data-id="element-140" />
          </div>

          <div className="py-4" data-id="element-141">
            <p className="text-sm uppercase tracking-wider font-semibold text-brand-text/50 line-through mb-1" data-id="element-142">
              Regular Price: $19.00
            </p>
            <div className="flex items-center justify-center space-x-2" data-id="element-143">
              <span className="text-5xl font-serif font-bold text-brand-accent" data-id="element-144">
                $6.36
              </span>
              <span className="text-sm font-bold text-brand-accent mt-4" data-id="element-145">
                USD
              </span>
              <span className="bg-brand-accent text-white text-xs font-bold px-2 py-1 rounded-full mt-4" data-id="element-146">
                -66%
              </span>
            </div>
          </div>

          <a href="http://plenava.com/cart/52538292371803id1:1" target="_blank" rel="noopener noreferrer" className="w-full bg-brand-cta hover:bg-brand-cta-hover text-white font-bold text-lg py-4 px-8 rounded-sm transition-all duration-200 flex items-center justify-center space-x-2 shadow-lg shadow-brand-cta/20 group no-underline" data-id="element-147">
            <span data-id="element-148">Get The 48-Hour Protocol Now</span>
            <ChevronRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-149" />
          </a>

          <div className="flex items-center justify-center space-x-2 text-xs text-brand-text/60 font-medium pt-2" data-id="element-150">
            <ShieldCheckIcon className="w-4 h-4" data-id="element-151" />
            <span data-id="element-152">Instant PDF Download. Access on any device.</span>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="pt-10 pb-4 text-center text-xs text-brand-text/50 space-y-2" data-id="element-153">
          <p data-id="element-154">© {new Date().getFullYear()} Plenava. All rights reserved.</p>
          <div className="flex items-center justify-center space-x-4" data-id="element-155">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-brand-text transition-colors underline underline-offset-2" data-id="element-156">
              Privacy Policy
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-brand-text transition-colors underline underline-offset-2" data-id="element-157">
              Terms & Conditions
            </button>
          </div>
          <p className="pt-2" data-id="element-158">Contact: plenavaweb@gmail.com</p>
        </footer>
      </main>

      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Privacy Policy" content={privacyContent} data-id="element-159" />
      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Terms & Conditions" content={termsContent} data-id="element-160" />
    </div>;
}